function fitBoundary(_a) {
    var boundary = _a.boundary, size = _a.size;
    var areaHeight = boundary.clientHeight;
    var areaWidth = boundary.clientWidth;
    var currentHeight = areaHeight;
    var currentWidth = (size.width * areaHeight) / size.height;
    if (currentWidth > areaWidth) {
        currentWidth = areaWidth;
        currentHeight = (size.height * areaWidth) / size.width;
    }
    return {
        width: currentWidth,
        height: currentHeight,
    };
}
function fillBoundary(_a) {
    var boundary = _a.boundary;
    return {
        width: boundary.clientWidth,
        height: boundary.clientHeight,
    };
}

export { fillBoundary, fitBoundary };
